module.exports = __webpack_public_path__ + "img/Seafoods.e6ac363f.jpg";